import "@hotwired/turbo-rails"
import "./channels"
import "./controllers"
import { createIcons, icons } from "lucide"

const applyTheme = (theme) => {
  const isDark = theme === "dark"
  document.documentElement.classList.toggle("dark", isDark)
  document.documentElement.style.colorScheme = isDark ? "dark" : "light"
}

const updateThemeLabel = () => {
  const isDark = document.documentElement.classList.contains("dark")
  document.querySelectorAll("[data-theme-label]").forEach((el) => {
    el.textContent = isDark ? "Light" : "Dark"
  })
}

const initTheme = () => {
  const savedTheme = window.localStorage.getItem("theme")
  const theme = savedTheme === "light" ? "light" : "dark"
  applyTheme(theme)
  updateThemeLabel()
}

const toggleTheme = () => {
  const nextTheme = document.documentElement.classList.contains("dark") ? "light" : "dark"
  window.localStorage.setItem("theme", nextTheme)
  applyTheme(nextTheme)
  updateThemeLabel()
}

const renderIcons = () => createIcons({ icons })

initTheme()

document.addEventListener("click", (event) => {
  if (event.target.closest("[data-theme-toggle]")) {
    toggleTheme()
  }
})

document.addEventListener("turbo:load", () => {
  initTheme()
  renderIcons()
})

document.addEventListener("turbo:render", () => {
  renderIcons()
})

document.addEventListener("turbo:before-stream-render", (event) => {
  const originalRender = event.detail.render
  event.detail.render = (streamElement) => {
    originalRender(streamElement)
    queueMicrotask(() => renderIcons())
  }
})
